module.exports = __webpack_public_path__ + "img/part3.ee3c065e.jpg";